export default __webpack_public_path__ + "static/media/img_15.fb54b9f3.jpg";